import React from "react";
import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import FunnelPage from "./pages/FunnelPage";
import CandidaturePageQCM from "./pages/CandidaturePageQCM";
import LegalPage from "./pages/LegalPage";

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();
  
  useEffect(() => {
    // Immediate scroll
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    
    // Backup scroll after a short delay (for lazy-loaded content)
    const timeoutId = setTimeout(() => {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    }, 50);
    
    return () => clearTimeout(timeoutId);
  }, [pathname]);
  
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<FunnelPage />} />
          <Route path="/candidature" element={<CandidaturePageQCM />} />
          <Route path="/legal/:page" element={<LegalPage />} />
          {/* Redirect old routes to home */}
          <Route path="/accueil" element={<Navigate to="/" replace />} />
          <Route path="/decouvrir" element={<Navigate to="/" replace />} />
          <Route path="/parcours" element={<Navigate to="/" replace />} />
          <Route path="/coachs" element={<Navigate to="/" replace />} />
          <Route path="/club" element={<Navigate to="/" replace />} />
          <Route path="/opportunites" element={<Navigate to="/" replace />} />
          <Route path="/programme" element={<Navigate to="/" replace />} />
          <Route path="/tarifs" element={<Navigate to="/" replace />} />
          <Route path="/histoire" element={<Navigate to="/" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
